import { toString } from 'cronstrue';

export const normalizeCron = (cron: string): string => {
  return cron
    .split(' ')
    .filter((segment) => segment.trim().length > 0)
    .join(' ');
};

type HumanReadableCronOptions = {
  throwError?: boolean;
  ampm?: boolean;
};
export const toHumanReadableCron = (
  cron: string,
  { throwError, ampm }: HumanReadableCronOptions = {}
): string | undefined => {
  try {
    return toString(cron, { use24HourTimeFormat: !ampm });
  } catch (err) {
    if (!throwError) {
      return;
    }
    throw err;
  }
};

export const suppressSecondsInCron = (cron: string): string => {
  const cronSegments = normalizeCron(cron).split(' ');

  if (cronSegments.length === 6) {
    return cronSegments.slice(1).join(' ');
  }

  return cron;
};

export const getTimeZoneAndCron = (
  cronString: string
): { cron: string; timeZone?: string } => {
  cronString = cronString.trim();

  if (!cronString.startsWith('CRON_TZ')) {
    return { cron: suppressSecondsInCron(cronString) };
  }

  const [timeZone, ...rest] = cronString.split(' ');

  return {
    cron: suppressSecondsInCron(rest.join(' ')),
    timeZone: timeZone.substring('CRON_TZ='.length),
  };
};

export const addTimeZoneToCron = (
  cronString: string,
  timeZone?: string
): string => {
  if (!timeZone) {
    return cronString;
  }
  return `CRON_TZ=${timeZone} ${cronString}`;
};
